<div class="mat-elevation-z8 tableoverflow">
  <table mat-table #table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          color="primary"
          (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
          >
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          color="primary"
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)"
          >
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Naam</th>
      <td mat-cell *matCellDef="let user">
        <a [routerLink]="['/members', user.memberID]">
          <app-member-name [member]="user"></app-member-name>
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="telephoneNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Telefoon</th>
      <td mat-cell *matCellDef="let user">
        {{ user.telephoneNumber }}
      </td>
    </ng-container>
    <ng-container matColumnDef="memberStatus">
      <th mat-header-cell *matHeaderCellDef>Lid Status</th>
      <td mat-cell *matCellDef="let user">
        {{ user.memberStatus.value }}
      </td>
    </ng-container>
    <ng-container matColumnDef="hasAccount">
      <th mat-header-cell *matHeaderCellDef>Account?</th>
      <td mat-cell *matCellDef="let user">
        @if (user.hasAccount) {
          <mat-icon>check</mat-icon>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="activatedAccount">
      <th mat-header-cell *matHeaderCellDef>Geactiveerd?</th>
      <td mat-cell *matCellDef="let user">
        @if (user.activated) {
          <mat-icon>check</mat-icon>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="mailSent">
      <th mat-header-cell *matHeaderCellDef>Mail Gestuurd?</th>
      <td mat-cell *matCellDef="let user">
        @if (user.mailSent) {
          <mat-icon>check</mat-icon>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
      <td mat-cell *matCellDef="let user">{{ user.email }}</td>
    </ng-container>

    <ng-container matColumnDef="vegetarian">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Vega</th>
      <td mat-cell *matCellDef="let user">{{ user.vegetarian ? 'Vega' : "Niet Vega"}}</td>
    </ng-container>

    <ng-container matColumnDef="filter">
      <th mat-header-cell *matHeaderCellDef>
        <button
          (click)="openExtraFilter = !openExtraFilter"
          matTooltip="Open Filtermenu"
          mat-icon-button
          >
          <mat-icon>filter_list</mat-icon>
        </button>
      </th>
    </ng-container>
    <ng-container matColumnDef="filter-list">
      <th
        mat-header-cell
        [attr.colspan]="collumns.length - 2"
        *matHeaderCellDef
      ></th>
    </ng-container>
    <ng-container matColumnDef="empty-cell">
      <th mat-header-cell *matHeaderCellDef></th>
    </ng-container>
    <ng-container matColumnDef="renewfilters">
      <th
        mat-header-cell
        *matHeaderCellDef
        [attr.colspan]="collumns.length - 1"
        >
        <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5px">
          <mat-chip-listbox fxFlex>
            <mat-chip-option
              (click)="applyBoolFilter('hasAccount')"
              matTooltip="Laat alleen leden met een account zien"
              >
              @if (filterValues.hasAccount) {
                <mat-icon>check</mat-icon>
              }
              Heeft Account
            </mat-chip-option>
            <mat-chip-option
              (click)="applyBoolFilter('activated')"
              matTooltip="Laat alleen niet-geactiveerde accounts zien"
              >
              @if (filterValues.activated) {
                <mat-icon>check</mat-icon>
              }
              Niet Geactiveerd</mat-chip-option
              >
              <mat-chip-option
                (click)="applyBoolFilter('davilexID')"
                matTooltip="Alleen accounts zonder DavilexID"
                >
                @if (filterValues.davilexID) {
                  <mat-icon>check</mat-icon>
                }
                DavilexID afwezig</mat-chip-option
                >
                <mat-chip-option
                  (click)="applyBoolFilter('vegetarian')"
                  matTooltip="Alleen vegetarische accounts"
                  >
                  @if (filterValues.vegetarian) {
                    <mat-icon>check</mat-icon>
                  }
                  Is vegetarisch</mat-chip-option
                  >
                </mat-chip-listbox>
                <form [formGroup]="filterForm" class="filter-form">
                  <mat-form-field fxFlex="20%" fxFlex.lt-sm="100%">
                    <mat-label>Lid Status</mat-label>
                    <mat-select formControlName="memberStatus" multiple #statusTypes>
                      @for (type of memberStatusTypes; track type) {
                        <mat-option
                          [value]="type"
                          >{{ type.value }}</mat-option
                          >
                        }
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field fxFlex>
                      <mat-label>Geslacht</mat-label>
                      <mat-select formControlName="memberSexs" multiple>
                        @for (type of memberSexTypes; track type) {
                          <mat-option
                            [value]="type"
                            >{{ type.value }}</mat-option
                            >
                          }
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field fxFlex="20%" fxFlex.lt-sm="100%">
                        <input
                          matInput
                          [matDatepicker]="df"
                          [max]="today"
                          placeholder="Lid geworden na:"
                          formControlName="dateFrom"
                          />
                          <mat-datepicker-toggle
                            matSuffix
                            [for]="df"
                          ></mat-datepicker-toggle>
                          <mat-datepicker #df></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field fxFlex="20%" fxFlex.lt-sm="100%">
                          <input
                            matInput
                            [matDatepicker]="dt"
                            [max]="today"
                            placeholder="Lid geworden voor:"
                            formControlName="dateTo"
                            />
                            <mat-datepicker-toggle
                              matSuffix
                              [for]="dt"
                            ></mat-datepicker-toggle>
                            <mat-datepicker #dt></mat-datepicker>
                          </mat-form-field>
                          <div fxFlex="20%">
                            <button mat-icon-button>
                              <mat-icon (click)="findMembers()">check</mat-icon>
                            </button>
                          </div>
                        </form>
                      </div>
                    </th>
                  </ng-container>
                  <ng-container matColumnDef="filter-input">
                    <th mat-header-cell *matHeaderCellDef>
                      <mat-form-field>
                        <input
                          matInput
                          (keyup)="applyFilter($event.target.value)"
                          placeholder="Filter op naam, davilexID of Email (Binnen de filters)..."
                          />
                        </mat-form-field>
                      </th>
                    </ng-container>
                    <tr
                      mat-header-row
                      *matHeaderRowDef="['filter', 'filter-list', 'filter-input']"
                      class="header row"
                    ></tr>
                    <tr
                      mat-header-row
                      [class.hidden]="openExtraFilter"
                      *matHeaderRowDef="['empty-cell', 'renewfilters']"
                      class="header row filterrow"
                    ></tr>
                    <tr mat-header-row *matHeaderRowDef="collumns"></tr>
                    <tr
                      mat-row
                      *matRowDef="let row; columns: collumns"
                      (click)="selection.toggle(row)"
                      [class.selected-row]="selection.isSelected(row)"
                    ></tr>
                  </table>

                  <mat-paginator [pageSizeOptions]="[10, 50, 100]"></mat-paginator>
                </div>

                @if (selection.selected.length > 0) {
                  <app-fab-menu>
                    <button
                      mat-mini-fab
                      color="secondary"
                      matTooltip="Zend Activatie Mail"
                      matTooltipPosition="before"
                      (click)="resendConfirmationMail()"
                      >
                      <mat-icon>send</mat-icon>
                    </button>
                    <button
                      mat-mini-fab
                      color="secondary"
                      matTooltip="Geef Diplomas"
                      matTooltipPosition="before"
                      (click)="giveCertificates()"
                      >
                      <mat-icon>rowing</mat-icon>
                    </button>
                    @if (isAdmin && selection.selected.length === 1) {
                      <button
                        mat-mini-fab
                        color="secondary"
                        matTooltip="Genereer Wachtwoord"
                        matTooltipPosition="before"
                        (click)="generatePassword()"
                        >
                        <mat-icon>vpn_key</mat-icon>
                      </button>
                    }
                    <button
                      mat-mini-fab
                      color="secondary"
                      matTooltip="Verander Status"
                      matTooltipPosition="before"
                      (click)="changeStatus()"
                      >
                      <mat-icon>accessibility_new</mat-icon>
                    </button>
                  </app-fab-menu>
                }
